<div
  class="determinate-progress-bar"
  [ngStyle]="{'transform': 'translate3d(' + percent + ', 0px, 0px)'}"
  *ngIf="isShow"
></div>